export const InquiryTypes = {
  VISIT: 'VISIT',
  REALISATION: 'REALISATION',
  ELAGAGE: 'ELAGAGE',
  CREATION: 'CREATION'
}



// WEBPACK FOOTER //
// ./src/constants/InquiryTypes.js